/**
 * Resolve Sentry DSN from a full URL or a Client Keys public key + ingest host + project id.
 */
export function resolveSentryDsn(rawDsn, ingestHost, projectId) {
  const raw = (rawDsn || '').trim();
  if (!raw) {
    return '';
  }
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }
  const host = (ingestHost || '').trim();
  const project = (projectId || '').trim();
  if (host && project) {
    return `https://${raw}@${host}/${project}`;
  }
  return '';
}
